import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { Card } from "@mui/material";
import { type SxProps, type Theme, useTheme } from "@mui/material/styles";
import { useAtom } from "jotai";

type Props = {
	className?: string;
	children: JSX.Element | JSX.Element[];
	sx?: SxProps<Theme>;
};

export const BlankCard = ({ children, className, sx }: Props) => {
	const [themeConfiguration] = useAtom(themeAtom);
	const theme = useTheme();
	const borderColor = theme.palette.divider;

	return (
		<Card
			sx={{
				p: "8px 14px",
				border: !themeConfiguration.isCardShadow
					? `1px solid ${borderColor}`
					: "none",
				position: "relative",
				...sx,
			}}
			className={className}
			elevation={themeConfiguration.isCardShadow ? 9 : 0}
			variant={!themeConfiguration.isCardShadow ? "outlined" : undefined}
		>
			{children}
		</Card>
	);
};
